import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useTranslation } from '../../hooks/useTranslation.jsx';

const { FiSearch, FiX, FiArrowRight } = FiIcons;

export default function SearchPage() {
  const { contentLanguage } = useTranslation();
  const [query, setQuery] = useState('');

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-black text-gray-900 mb-4">
          {contentLanguage === 'el' ? 'Αναζήτηση στην Πλατφόρμα' : 'Search the Platform'}
        </h1>
        <p className="text-lg text-gray-500">
          {contentLanguage === 'el' 
            ? 'Βρείτε πόρους, οργανισμούς και πρακτική υποστήριξη.' 
            : 'Find resources, organizations, and practical support.'}
        </p>
      </div>

      <div className="relative mb-12">
        <SafeIcon icon={FiSearch} className="absolute left-6 top-1/2 -translate-y-1/2 text-gray-400 text-2xl" />
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={contentLanguage === 'el' ? 'Πληκτρολογήστε για αναζήτηση...' : 'Type to search...'}
          className="w-full pl-16 pr-16 py-6 text-xl rounded-3xl border-2 border-gray-100 focus:border-blue-500 focus:ring-0 transition-all shadow-sm"
          autoFocus
        />
        {query && (
          <button 
            onClick={() => setQuery('')}
            className="absolute right-6 top-1/2 -translate-y-1/2 p-2 hover:bg-gray-100 rounded-full text-gray-400 transition-colors"
          >
            <SafeIcon icon={FiX} className="text-xl" />
          </button>
        )}
      </div>

      <div className="space-y-4">
        <p className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-4">
          {contentLanguage === 'el' ? 'Προτεινόμενες Αναζητήσεις' : 'Suggested Searches'}
        </p>
        <div className="flex flex-wrap gap-2">
          {['Chemotherapy', 'Nutrition', 'Support Groups', 'Hospitals', 'Greek NGO'].map((tag) => (
            <button
              key={tag}
              onClick={() => setQuery(tag)}
              className="px-4 py-2 bg-gray-50 text-gray-600 rounded-full hover:bg-gray-100 transition-colors border border-gray-100"
            >
              {tag}
            </button>
          ))}
        </div>
      </div>

      {query && (
        <motion.div 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mt-12 p-12 text-center bg-gray-50 rounded-3xl border-2 border-dashed border-gray-200"
        >
          <p className="text-gray-500 mb-2">
            {contentLanguage === 'el' ? 'Αναζήτηση για' : 'Searching for'} "{query}"...
          </p>
          <p className="text-sm text-gray-400">
            {contentLanguage === 'el' ? 'Τα αποτελέσματα θα εμφανιστούν εδώ.' : 'Results will appear here.'}
          </p>
        </motion.div>
      )}
    </div>
  );
}